/**
 * Codes des plans Zoho des ABONNEMENTS récurrents (Starter / Focus / Premium).
 *
 * ⚠️ Ces codes ne suivent AUCUNE règle de suffixe : l'annuel est « _ANN_ » pour
 * Starter mais « _AN_ » pour Focus et Premium. Le code les construisait par
 * concaténation (`AN` pour premium, `ANN` sinon) et fabriquait donc un plan
 * inexistant pour Focus annuel — Zoho refusait la création de la page de
 * paiement. D'où cette table explicite, source unique côté front ET serveur :
 * ne JAMAIS reconstruire un code par concaténation.
 *
 * Les packs one-shot (`Bizcoach_*_Pack50_*`) ne figurent pas ici : ils sont lus
 * en base (`licences.zoho_plan_code`, cf. `lib/oneshot-checkout.ts`).
 */

export type PlanTier = "starter" | "focus" | "premium";
export type PlanInterval = "monthly" | "yearly";

/** tier → { périodicité → code de plan Zoho }. */
export const SUBSCRIPTION_PLAN_CODES: Record<PlanTier, Record<PlanInterval, string>> = {
  starter: { monthly: "LIC_DEB_V20260218", yearly: "LIC_DEB_ANN_V20260218" },
  focus:   { monthly: "LIC_AVA_V20260218", yearly: "LIC_AVA_AN_V20260218" },
  premium: { monthly: "LIC_EXP_V20260218", yearly: "LIC_EXP_AN_V20260218" },
};

/** Code de plan Zoho pour un tier + une périodicité. */
export function getSubscriptionPlanCode(tier: PlanTier, interval: PlanInterval): string {
  return SUBSCRIPTION_PLAN_CODES[tier][interval];
}

/** Tier d'un code de plan (le segment DEB/AVA/EXP), `null` si inconnu. */
export function getTierFromPlanCode(planCode: string): PlanTier | null {
  for (const tier of Object.keys(SUBSCRIPTION_PLAN_CODES) as PlanTier[]) {
    const codes = SUBSCRIPTION_PLAN_CODES[tier];
    if (codes.monthly === planCode || codes.yearly === planCode) return tier;
  }
  return null;
}
